import { render, staticRenderFns } from "./custom-form-number.vue?vue&type=template&id=b1b75bf0&scoped=true"
import script from "./custom-form-number.vue?vue&type=script&lang=js"
export * from "./custom-form-number.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b75bf0",
  null
  
)

export default component.exports